import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterExperimentalLoaderProjectDetail = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("experimental/lib")
      .then((lib) => {
        resolve({
          default: () => <lib.default.LoaderPageProjectDetail />,
        });
      })
      .catch(reject);
  });
});

export const LazyExperimentalLoaderProjectDetail = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterExperimentalLoaderProjectDetail />
    </Suspense>
  );
};
